import { Card, CardContent, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react'
import { Apiurl } from '../api_urls';
import { GToaster } from './g_toaster';
const toster = new GToaster()
const UploadImage = ({ type, id, handleChange, photo }) => {
    const [image, setImage] = useState(null)
    const [uploadbtn, setuploadbtn] = useState(false)

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setImage({ imageUrl, original: file });
        }
    };

    const triggerFileInput = () => {
        document.getElementById('imageUpload').click();
    };


    const uploadPicture = async () => {
        setuploadbtn(true)
        let formdata = new FormData()
        formdata.append("type", type)
        formdata.append("id", id)
        formdata.append("file", image?.original)
        axios.post(Apiurl.UPLOAD_PROFILE_PICTURE, formdata).then((result) => {
            if (result?.data?.status === 200) {
                console.log(result?.data)
                toster.success({ title: "Image Uploaded Successfully" })
                handleChange()
                setuploadbtn(false)
            } else {
                setuploadbtn(false)
            }

        }).catch(() => {
             toster.error({ title: "Server Error" })
            setuploadbtn(false)
        })



    }

    return (
        <Card>
            <CardContent>
                <div className="profile-card" style={{ textAlign: "center" }}>
                    <Typography variant='h5' sx={{pb:2}}>Upload Profile Image</Typography>
                    <div className="profile-image-container" style={{ textAlign: "center", }}>
                        <img
                            src={image?.imageUrl || photo}
                            alt="Profile"
                            className="profile-image"
                            style={{ width: "250px", height: "250px" }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';
                            }}
                        />
                    </div>
                    <input
                        type="file"
                        id="imageUpload"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: 'none' }}
                    />
                    <button className="upload-button" onClick={triggerFileInput} style={{ marginTop: "5px" }}>
                        Choose Image
                    </button>

                    <div style={{ paddingTop: "30px", width: "100%" }}>
                        <button className="btn btn-success" disabled={uploadbtn || !image?.imageUrl} onClick={uploadPicture}>
                            {uploadbtn && <CircularProgress size={20} sx={{ color: "white" }} />}&nbsp;&nbsp; Upload Picture
                        </button>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export default UploadImage